import React from 'react'
import Brands from '../components/Brands';
import Hero from '../components/Hero';
import Items from '../components/Items';
import Navbar from '../components/Navbar';
const Home = () => {
  return (
    <div>
    <Navbar/>
    <Hero/>
    <Items/>
    <Brands/>
    
    </div>
  )
}

export default Home
